export default "__VITE_ASSET__CBoOK_Mm__"